/**
 * Wrapper above the signar hub for promisifying invoke method and convenient unsubscribe
 */
export default class SignalRHub {
    constructor(connection, name) {
        this.connection = connection;
        this.instance = connection.createHubProxy(name);
        this.name = name;
    }

    subscribe(type, handler) {
        this.instance.on(type, handler);

        return () => {
            this.instance.off(type, handler);
        };
    }

    invoke() {
        return new Promise((resolve, reject) => {
            this.instance.invoke.apply(this.instance, arguments).done((result) => {
                resolve(result);
            }).fail((error) => {
                reject(error);
            });
        })
    }
}



// WEBPACK FOOTER //
// ./app/general/js/signalr-hub.js